// Signing key decoded at runtime (XOR-encoded; no plain string in bundle)
const _x = 0x42;
const _c = [48, 49, 111, 49, 47, 65, 48, 47, 94, 111, 65, 47, 75];

const config = {
  defaultEndpoint: __API_HOST__,
  collectPath: 'collect',
  bbPath: 'bb',
  submitPath: 'submit',
  fpDefaults: {
    extensions: 'auto',
    prewarm: true,
    cpuBenchPrewarm: 'auto',
    renderPrewarm: 'auto',
    gpuBenchmark: 'auto',
    storageTimeoutMs: 'auto',
    androidStorageTimeoutMs: 800,
    preconnect: true,
  },
  get _k() {
    return String.fromCharCode(..._c.map((n) => n ^ _x));
  },
};

module.exports = config;
